module.exports = __webpack_public_path__ + "static/img/Shape.39f16db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoDetail/Shape.svg
// module id = f5Ux
// module chunks = 0